import api from './api';

const postingService = {
  // Party Posting Profiles (Customer/Supplier)
  getPartyProfiles: () => api.get('/partypostingprofiles'),
  getPartyProfile: (id: number) => api.get(`/partypostingprofiles/${id}`),
  createPartyProfile: (data: any) => api.post('/partypostingprofiles', data),
  updatePartyProfile: (id: number, data: any) => api.put(`/partypostingprofiles/${id}`, data),
  deletePartyProfile: (id: number) => api.delete(`/partypostingprofiles/${id}`),

  // Product Posting Profiles
  getProductProfiles: () => api.get('/productpostingprofiles'),
  getProductProfile: (id: number) => api.get(`/productpostingprofiles/${id}`),
  createProductProfile: (data: any) => api.post('/productpostingprofiles', data),
  updateProductProfile: (id: number, data: any) => api.put(`/productpostingprofiles/${id}`, data),
  deleteProductProfile: (id: number) => api.delete(`/productpostingprofiles/${id}`),

  // Post invoices to ledger
  postSalesInvoice: (id: number) => api.post(`/invoices/${id}/post-to-ledger`),
  postPurchaseInvoice: (id: number) => api.post(`/purchaseinvoices/${id}/post-to-ledger`),

  // Subledger
  getSubledgerEntries: (params?: { partyType?: string; partyId?: number }) =>
    api.get('/subledger/entries', { params }),
  getSubledgerBalances: (partyType?: string) =>
    api.get('/subledger/balances', { params: partyType ? { partyType } : {} }),
  getAgingReport: (partyType: string = 'CUSTOMER') =>
    api.get('/subledger/aging', { params: { partyType } }),
};

export default postingService;
